var exports = {
  "cy": "xfd349460--72e91f--author",
  "my": "xfd349460--72e91f--avatar",
  "O0": "xfd349460--72e91f--rating",
  "uf": "xfd349460--72e91f--stars",
};

module.exports = exports;
